import React from 'react';

const SortIndicator = ({ isActive, direction }) => {
  if (!isActive) return <span className="sort-icon">⇅</span>;
  return (
    <span className="sort-icon active">
      {direction === 'asc' ? '↑' : '↓'}
    </span>
  );
};

export default SortIndicator;
